import { getToken } from '../utils/getToken'

import { wrapFetch } from './FetchHelper'

export default {
  getAll,
  get,
  create,
  update,
  remove,
}

function getAll() {
  return wrapFetch(
    fetch('/api/transportationservices', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  )
}

function get(id) {
  return wrapFetch(
    fetch(`/api/transportationservices/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }),
  )
}

function create(model) {
  return wrapFetch(
    fetch('/api/transportationservices', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(model),
    }),
  )
}

function remove(id) {
  return wrapFetch(
    fetch(`/api/transportationservices/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }),
  )
}

function update(model) {
  return wrapFetch(
    fetch('/api/transportationservices', {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(model),
    }),
  )
}
